import React from 'react'
import { connect } from 'react-redux'
import { Button, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { Link } from 'react-router-dom';

function CreateCustomerTopBar(props) {
    const { handleFormSubmission, userId, step, setStep, loading, formik } = props
    return (
        <div className="cats-all-btns justify-content-between d-flex border-bottom st-border-light pad-15-R">
            <div className="cats-all-btns-inner d-flex flex-wrap justify-content-start  pad-12-B ">
                <div className="app-header-wrapper heading-md d-flex align-items-center justify-content-start customer-top-heading mb-0">
                    <p className="app-heading text-capitalize">Customer Information</p>
                </div>
            </div>
            <div className="cats-all-btns-inner d-flex flex-wrap justify-content-end pad-12-B customer-right-btn">
                <Link to="/my-sales/customers"
                    disabled={loading}
                    className="st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2">
                    <FeatherIcon
                        icon="delete"
                        size="14"
                        className="icon me-1" />
                    Back
                </Link>
                <Button className="st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2"
                    onClick={() => { formik.resetForm() }}
                    disabled={loading}
                >
                    <FeatherIcon
                        icon="rotate-cw"
                        size="14"
                        className="icon me-1" />
                    Reset
                </Button>
                {(userId && step === 2 && <Link
                    to="/my-sales/customers"
                    type="submit"
                    className={`st-btn st-btn-sm st-btn-gray d-flex align-items-center justify-content-center me-2`} // ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}
                    disabled={loading}
                >
                    <span>Skip Address</span>
                </Link>)}
                <Button
                    type="submit"
                    // type={(isAddressFilled_ && isDetailsFilled_) ? "submit" : "button"}
                    className={`st-btn st-btn-sm st-btn-primary d-flex align-items-center justify-content-center`} // ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}
                    onClick={(e) => {
                        if (step === 1 || userId) {
                            handleFormSubmission(e, false)
                        } else {
                            setStep(1)
                        }
                    }}
                    disabled={loading}
                >
                    {
                        loading ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            <span>{(userId && step === 2) ? "Add Address" : "Create Customer"}</span>
                        )
                    }
                </Button>
            </div>
        </div >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateCustomerTopBar)